<template>
  <div>
    <v-data-table
      :headers="acceptanceTryInstallDivideDataTableHeaders"
      :items="tryInstallDivideList"
      class="elevation-1 ma-5"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>驗收單劃分單據</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mx-2"
            @click="openSelectItemDivideInstallOrRemove"
            v-if="!hasTryInstallDivide"
            :disabled="!editedInstallationAcceptance.IsAcceptance"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowSelectItemDivideInstallOrRemoveDialog" fullscreen persistent>
            <v-card>
              <v-card-title>劃分安裝、拆機單據</v-card-title>
              <v-card-text>
                <v-data-table
                  v-model="selectedItems"
                  :headers="selectItemDivideInstallOrRemoveDataTableHeaders"
                  :items="computedSelectedItems"
                  class="elevation-1 my-5"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_data')"
                  :no-results-text="$t('common_no_results')"
                  :footer-props="{
                    'items-per-page-options': [30, 50, 100],
                    'items-per-page-text': $t('item_rows_per_page'),
                  }"
                  item-key="Index"
                  show-select
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>履歷卡資訊</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        class="mx-2"
                        v-if="isAdd"
                        :disabled="selectedItems.length === 0"
                        @click="isShowSelectDivideInstallOrRemoveDialog = true"
                      >
                        更新劃分安裝、拆機
                      </v-btn>
                      <v-dialog
                        v-model="isShowSelectDivideInstallOrRemoveDialog"
                        v-if="isShowSelectDivideInstallOrRemoveDialog"
                        persistent
                        :max-width="800"
                      >
                        <v-card>
                          <v-card-title></v-card-title>
                          <v-card-text>
                            <ValidationObserver ref="selectedTryInstallDivideType">
                              <ValidationProvider
                                name="劃分安裝、拆機"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  v-model="selectedTryInstallDivideType"
                                  item-text="Name"
                                  item-value="Type"
                                  small-chips
                                  multiple
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :items="tryInstallDivideTypeList"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    劃分安裝、拆機
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </ValidationObserver>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="error"
                              text
                              @click="closeSelectDivideInstallOrRemoveDialog"
                            >
                              {{ $t('common_cancel') }}
                            </v-btn>
                            <v-btn color="success" text @click="updateResumeItems">
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.BuyOrRentType`]="{ item }">
                    {{ turnBuyOrRentType(item.BuyOrRentType) }}
                  </template>
                  <template v-slot:[`item.InstallPosition`]="{ item }">
                    {{ turnInstallPositionType(item.InstallPosition) }}
                  </template>
                  <template v-slot:[`item.TryInstallDivideType`]="{ item }">
                    {{ turnTryInstallDivideType(item.TryInstallDivideType) }}
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeSelectItemDivideInstallOrRemoveDialog">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="success" v-if="isAdd" text @click="divideInstallOrRemoveDialog">
                  確認劃分
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.InvalidTime`]="{ item }">
        {{ convertToDateTimeFormat(item.InvalidTime) }}
      </template>
      <template v-slot:[`item.View`]="{ item }">
        <v-btn color="primary" @click="isShowDivideInstallOrRemoveDialogBtn(item)">
          查看
        </v-btn>
        <v-btn
          color="error"
          class="ml-2"
          :disabled="item.IsInvalid"
          @click="isShowInvalidDivideInstallOrRemoveDialogBtn(item)"
        >
          作廢
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="isShowInvalidDivideInstallOrRemoveDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>確定要作廢?</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <ValidationObserver ref="invalidDivideInstallOrRemove">
                <ValidationProvider name="作廢原因" rules="required" v-slot="{ errors }">
                  <v-textarea outlined v-model="invalidReason" :error-messages="errors[0]">
                    <template v-slot:label>
                      <span class="red--text">
                        <strong>* </strong>
                      </span>
                      作廢原因
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </ValidationObserver>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeInvalidDivideInstallOrRemoveDialog">
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn color="success" text @click="saveShowInvalidDivideInstallOrRemoveDialog">
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpResume, HttpAcceptanceTryInstallDivide, HttpInstallPosition } from '@/js/http-Manager'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { TryInstallDivideType } from '@/js/TryInstallDivideType'
export default {
  name: 'SelectDivideItem',
  props: {
    editedInstallationAcceptance: {
      type: Object,
      default: () => {}
    },
    tab: {
      type: String
    }
  },
  data: () => ({
    tryInstallDivideTypeInstall: TryInstallDivideType,
    isShowSelectItemDivideInstallOrRemoveDialog: false,
    resumeItems: [],
    tryInstallDivideList: [],
    tryInstallDivideTypeList: [],
    selectedItems: [],
    isShowSelectDivideInstallOrRemoveDialog: false,
    selectedTryInstallDivideType: [],
    isError: false,
    isAdd: false,
    isShowInvalidDivideInstallOrRemoveDialog: false,
    invalidReason: '',
    tryInstallDivideIndex: -1,
    installPositionList: []
  }),
  async mounted () {
    await this.getResumeItems()
    await this.getTryInstallDivideTypeList()
    await this.getAcceptanceTryInstallDivide()
    await this.getInstallPositionList()
  },
  watch: {
    async tab (val) {
      if (val === 'tab-3') {
        await this.getAcceptanceTryInstallDivide()
      }
    },
    selectedTryInstallDivideType (list) {
      this.checkTryInstallDivideType(list)
    }
  },
  computed: {
    computedSelectedItems () {
      let array = []
      this.resumeItems.forEach((element, index) => {
        array.push(Object.assign(element, { Index: index }))
      })
      return array
    },
    acceptanceTryInstallDivideDataTableHeaders () {
      return [
        { text: '單號', align: 'start', value: 'Number' },
        {
          text: '是否作廢',
          align: 'center',
          value: 'IsInvalid',
          sortable: false
        },
        {
          text: '作廢時間',
          align: 'center',
          value: 'InvalidTime',
          sortable: false
        },
        {
          text: '作廢人',
          align: 'start',
          value: 'InvalidBy',
          sortable: false
        },
        {
          text: '作廢原因',
          align: 'start',
          value: 'InvalidReason',
          sortable: false
        },
        {
          text: '查看',
          align: 'center',
          value: 'View',
          sortable: false
        }
      ]
    },
    selectItemDivideInstallOrRemoveDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: '是否需要安裝',
          align: 'start',
          value: 'IsNeedInstall'
        },
        {
          text: '劃分安裝、拆機',
          align: 'start',
          value: 'TryInstallDivideType'
        }
      ]
    },
    hasTryInstallDivide () {
      return (
        this.tryInstallDivideList.length > 0 &&
        this.tryInstallDivideList.findIndex((x) => !x.IsInvalid) !== -1
      )
    }
  },
  methods: {
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return ''
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async getAcceptanceTryInstallDivide () {
      let params = {
        acceptanceNumber: this.editedInstallationAcceptance.Number
      }
      let response = await HttpAcceptanceTryInstallDivide.GetTryInstallDividesListByAcceptanceNumber(
        params
      )
      this.tryInstallDivideList = response && response.status === 200 ? response.data.Data : []
    },
    checkTryInstallDivideType (list) {
      if (list && list.length === 1) {
        if (list[0] === this.tryInstallDivideTypeInstall.TryInstallChange) {
          this.isError = true
          alert('轉新良品一定要有拆品項')
        } else {
          this.isError = false
        }
      } else if (list && list.length > 1) {
        // 檢查是否同時包含 TryInstallChange 和 TryInstallOriginal
        const hasChange = list.includes(this.tryInstallDivideTypeInstall.TryInstallChange)
        const hasOriginal = list.includes(this.tryInstallDivideTypeInstall.TryInstallOriginal)

        if (hasChange && hasOriginal) {
          this.isError = true
          alert('轉新良品和原品項不能同時選擇')
        } else {
          this.isError = false
        }
      } else {
        this.isError = false
      }
    },
    closeSelectDivideInstallOrRemoveDialog () {
      this.isShowSelectDivideInstallOrRemoveDialog = false
      this.selectedItems = []
      this.selectedTryInstallDivideType = []
      this.isError = false
    },
    async updateResumeItems () {
      let errorMessage = ''
      this.checkTryInstallDivideType(this.selectedTryInstallDivideType)
      const isValid = await this.$refs.selectedTryInstallDivideType.validate()
      if (isValid) {
        if (!this.isError) {
          this.selectedItems.forEach((element) => {
            const hasChange = this.selectedTryInstallDivideType.includes(
              this.tryInstallDivideTypeInstall.TryInstallChange
            )
            if (hasChange && !element.HasSerialNumber) {
              errorMessage += element.Name + '，轉新良品一定只能是有機器序號的品項\n'
            } else {
              this.$set(
                this.resumeItems[element.Index],
                'TryInstallDivideType',
                this.selectedTryInstallDivideType
              )
            }
          })
          this.closeSelectDivideInstallOrRemoveDialog()
          if (errorMessage) {
            alert(errorMessage)
          }
        }
      }
    },
    async getTryInstallDivideTypeList () {
      let response = await HttpAcceptanceTryInstallDivide.GetTryInstallDivideTypeList()
      this.tryInstallDivideTypeList = response.status === 200 ? response.data.Data : []
    },
    async openSelectItemDivideInstallOrRemove () {
      this.isAdd = true
      await this.getResumeItems()
      this.isShowSelectItemDivideInstallOrRemoveDialog = true
    },
    isShowDivideInstallOrRemoveDialogBtn (item) {
      this.isAdd = false
      let acceptanceTryInstallDivide = this.tryInstallDivideList.find(
        (x) => x.Number === item.Number
      )
      this.resumeItems = acceptanceTryInstallDivide.DivideItems
      this.isShowSelectItemDivideInstallOrRemoveDialog = true
    },
    closeSelectItemDivideInstallOrRemoveDialog () {
      this.isShowSelectItemDivideInstallOrRemoveDialog = false
      this.resumeItems = []
      this.selectedItems = []
      this.selectedTryInstallDivideType = []
      this.isError = false
      this.isAdd = false
    },
    async divideInstallOrRemoveDialog () {
      let param = {
        CustomerId: this.editedInstallationAcceptance.CustomerId,
        AcceptanceNumber: this.editedInstallationAcceptance.Number,
        DivideItems: this.resumeItems
      }
      let isError = false
      this.resumeItems.forEach((element) => {
        if (!element.TryInstallDivideType || element.TryInstallDivideType.length === 0) {
          isError = true
        }
      })
      if (isError) {
        alert('請選擇劃分安裝、拆機')
      } else {
        let response = await HttpAcceptanceTryInstallDivide.DivideInstallOrRemoveFlow(param)
        if (response && response.status === 200) {
          if (response.data.Data) {
            alert(response.data.Data)
          } else {
            await this.getAcceptanceTryInstallDivide()
            this.closeSelectItemDivideInstallOrRemoveDialog()
            this.$emit('searchEditedAcceptance')
          }
        }
      }
    },
    async getResumeItems () {
      let response = await HttpResume.GetResumeItemsDto({
        customerId: this.editedInstallationAcceptance.CustomerId,
        licensePlate: this.editedInstallationAcceptance.LicensePlate
      })
      this.resumeItems = response.status === 200 ? response.data.Data : []
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnInstallPositionType (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.installPositionList
        )
      }
    },
    turnTryInstallDivideType (list) {
      if (list && list.length > 0) {
        return list.map((item) => TryInstallDivideType.TryInstallDivideTypeName(item)).join(',')
      }
    },
    isShowInvalidDivideInstallOrRemoveDialogBtn (item) {
      this.tryInstallDivideIndex = this.tryInstallDivideList.indexOf(item)
      this.isShowInvalidDivideInstallOrRemoveDialog = true
    },
    closeInvalidDivideInstallOrRemoveDialog () {
      this.isShowInvalidDivideInstallOrRemoveDialog = false
      this.invalidReason = ''
      this.tryInstallDivideIndex = -1
    },
    async saveShowInvalidDivideInstallOrRemoveDialog () {
      const isValid = await this.$refs.invalidDivideInstallOrRemove.validate()
      if (isValid) {
        let tryInstallDivide = this.tryInstallDivideList[this.tryInstallDivideIndex]
        tryInstallDivide.InvalidReason = this.invalidReason

        let response = await HttpAcceptanceTryInstallDivide.UpdateInvalidDivideInstallOrRemove(
          tryInstallDivide
        )
        if (response && response.status === 200) {
          await this.getAcceptanceTryInstallDivide()
          this.closeInvalidDivideInstallOrRemoveDialog()
          this.$emit('searchEditedAcceptance')
        }
      }
    }
  }
}
</script>
